import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { navModule } from './modules/nav';
import { appUpdateNotificationModule } from './modules/appUpdateNotification';
import { settingsModule } from './modules/settings';

import { SignInPage } from '@backstage/core-components';
import { microsoftAuthApiRef } from '@backstage/core-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { businessApplicationsPlugin } from '@internal/backstage-plugin-business-applications';
import { complianceManagementPlugin } from '@internal/backstage-plugin-compliance-management';
import { exceptionsPlugin } from '@internal/backstage-plugin-exceptions';
import { riskLibraryPlugin } from '@internal/backstage-plugin-risk-library';
import { checklistApprovalPlugin } from '@internal/backstage-plugin-checklist-approval';
import { grrDashboardPlugin } from '@internal/backstage-plugin-grr-dashboard';

const signInPageModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    SignInPageBlueprint.make({
      params: {
        loader: async () => props =>
          (
            <SignInPage
              {...props}
              providers={[
                {
                  id: 'microsoft',
                  title: 'Microsoft',
                  message: 'Sign in with Microsoft Entra ID',
                  apiRef: microsoftAuthApiRef,
                },
                // 'guest',
              ]}
            />
          ),
      },
    }),
  ],
});

export default createApp({
  features: [
    catalogPlugin,
    navModule,
    settingsModule,
    appUpdateNotificationModule,
    signInPageModule,
    businessApplicationsPlugin,
    complianceManagementPlugin,
    exceptionsPlugin,
    riskLibraryPlugin,
    checklistApprovalPlugin,
    grrDashboardPlugin,
  ],
});
